module.exports = __webpack_public_path__ + "img/powered-by-light.84d0a609.svg";